import { donWSURL } from './values';
import './store';
export function watchTimeline(hashtag, newTootCallback) {
    const socket = hashtag !== null
        ? new WebSocket(`${donWSURL}?stream=hashtag:local&tag=${hashtag}`)
        : new WebSocket(`${donWSURL}?stream=public:local`);
    socket.onmessage = function (e) {
        const data = JSON.parse(e.data);
        console.log('EVENT:', data);
        if (data.event === 'update') {
            const status = JSON.parse(data.payload);
            console.log('STATUS:', status);
            newTootCallback(status.content, status.account.display_name || status.account.username);
        }
    };
    return socket;
}
